import { render, staticRenderFns } from "./ConfigurationWizardLetsGo.vue?vue&type=template&id=a528d20c&"
import script from "./ConfigurationWizardLetsGo.vue?vue&type=script&lang=js&"
export * from "./ConfigurationWizardLetsGo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports